<h2 class="my-0">Zielerreichung {{ revenueData().currentMonth }}</h2>
<p class="text-small">Stand: {{ revenueData().updated_at | date: 'dd.MM.yyyy HH:mm' }}</p>
<div class="d-flex align-items-center mb-s">
  <img src="assets/icons/packungen.svg" alt="Package icon">
  <div class="ml-s">
    <span class="small p-0 mb-0">Anzahl RX Packungen <span class="material-symbols-outlined" matTooltip="inkl. Hochpreis">info</span></span><br>
    <span>IST&nbsp;</span><span class="text-xlarge ml-xs">{{ revenueData().rx_packet_count | number}}</span>
    @if (revenueData().rx_packet_percentage < 100) {
      <span class="mx-xs">&nbsp;SOLL&nbsp;</span><span class="text-xlarge">{{ revenueData().target_rx_packets | number }}</span>
    }
  </div>

  @if (sessionShowCelebration()) {
    <img alt="" src="assets/images/Zielerreichung.gif" height="90" width="90">
  }
</div>
@if (revenueData().rx_packet_percentage < 100) {
  <div class="d-flex aic" [style.gap]="'10px'">
    <mat-progress-bar mode="determinate"
                      color="base"
                      [value]="revenueData().rx_packet_percentage"
                      [style]="'--mat-progress-bar-track-height: 16px; border-radius: 25px; ' +
                       '--mat-progress-bar-active-indicator-height: 16px; --mat-progress-bar-track-color: #f8f9fa;' +
                       '--mat-progress-bar-active-indicator-color: ' + progressColor()">>
    </mat-progress-bar>
    <span>{{ revenueData().rx_packet_percentage | number:'1.0-0' }}%</span>
  </div>
  <p class="small">Ihnen fehlen noch <strong>{{ revenueData().rx_packet_delta | number }}</strong> RX Packungen zur
    Zielerreichung.</p>
}

@if (revenueData().rx_packet_percentage >= 100) {
  @if (sessionShowCelebration()) {
    <div class="d-flex aic" [style.gap]="'10px'">
      <mat-progress-bar mode="determinate"
                        color="base"
                        [value]="revenueData().rx_packet_percentage"
                        [style]="'--mat-progress-bar-track-height: 16px; border-radius: 25px; ' +
                       '--mat-progress-bar-active-indicator-height: 16px; --mat-progress-bar-track-color: #f8f9fa;' +
                       '--mat-progress-bar-active-indicator-color: #92d400'">>
      </mat-progress-bar>
      <span>100%</span>
<!--      <span>{{ revenueData().rx_packet_percentage | number:'1.0-0' }}%</span>-->
    </div>
    <p class="small">Herzlichen Glückwunsch! Sie haben das Ziel erreicht.</p>
  }
  @if (!sessionShowCelebration()) {
    <p class="pt-0 small">Sie haben den Sollwert erreicht.</p>
  }
}
